import { render } from "./DataParseComp.vue?vue&type=template&id=74c6ecf0&scoped=true"
import script from "./DataParseComp.vue?vue&type=script&lang=js"
export * from "./DataParseComp.vue?vue&type=script&lang=js"

import "./DataParseComp.vue?vue&type=style&index=0&id=74c6ecf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c6ecf0"]])

export default __exports__